import React from 'react';
import { injectIntl } from 'react-intl';
import { Form } from '@ant-design/compatible';
import { Select } from 'antd';
import PropTypes from 'prop-types';
import { getJobMessages } from '../../../../../constants/messages';
import { objectToArray } from '../../../../../utilities/util';
import CircleBadge from '../../../../GlobalComponents/CircleBadge';
import { JOBTYPES } from '../../../constants';
import '@ant-design/compatible/assets/index.css';
const { Option } = Select;

let jobMessages = getJobMessages();

const messages = {
	...jobMessages,
};

const FormItem = Form.Item;

class Type extends React.Component {
	getIntl = (str) => this.props.intl.formatMessage({ ...messages[str] });

	buildOptions = () => {
		const { getIntl } = this;
		return objectToArray(JOBTYPES).map((type) => (
			<Option key={type.id} value={type.id}>
				{getIntl(type.intl)} <CircleBadge color={type.backgroundColor} />
			</Option>
		));
	};

	render() {
		const { props, getIntl, buildOptions } = this;
		const { getFieldDecorator } = props.form;
		let options = buildOptions();
		return (
			<FormItem label={getIntl('jobType')}>
				{getFieldDecorator('type')(
					<Select
						className="job-full-component"
						showSearch
						allowClear
						placeholder={getIntl('jobType')}
						optionFilterProp="children"
						notFoundContent={getIntl('notFound')}
						dropdownMatchSelectWidth={false}
					>
						{options}
					</Select>
				)}
			</FormItem>
		);
	}
}

Type.propTypes = {
	intl: PropTypes.object.isRequired,
	form: PropTypes.object.isRequired,
};

export default injectIntl(Type);
